exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".script-control-list{border-radius:0}.script-control-btn{width:100%;border-radius:0;height:var(--script-control-btn-height);border-right:1px solid var(--neutral300)}.script-control-btn:last-child{border-bottom-right-radius:var(--border-radius);border:none}.script-control-btn:first-child{border-bottom-left-radius:var(--border-radius)}.primary-control-btn{background:var(--accent-green100);color:var(--accent-green600)}.warning-control-btn:hover{background:var(--accent-red100);color:var(--accent-red600)}", ""]);

// exports
